export default "__VITE_ASSET__CQUAC$_f__"